// Copyright (C) 2012-2026 Zammad Foundation, https://zammad-foundation.org/

export const baseColors = [
  [
    {
      value: 'rgb(239, 68, 68)',
      label: __('Change text color to red (%s)'),
    },
    {
      value: 'rgb(235, 61, 79)',
      label: __('Change text color to red (%s)'),
    },
    {
      value: 'rgb(237, 97, 118)',
      label: __('Change text color to red (%s)'),
    },
    {
      value: 'rgb(241, 152, 167)',
      label: __('Change text color to red (%s)'),
    },
  ],
  [
    {
      value: 'rgb(205, 121, 45)',
      label: __('Change text color to orange (%s)'),
    },
    {
      value: 'rgb(233, 159, 59)',
      label: __('Change text color to orange (%s)'),
    },
    {
      value: 'rgb(243, 193, 79)',
      label: __('Change text color to orange (%s)'),
    },
    {
      value: 'rgb(246, 211, 102)',
      label: __('Change text color to orange (%s)'),
    },
  ],
  [
    {
      value: 'rgb(80, 140, 70)',
      label: __('Change text color to green (%s)'),
    },
    {
      value: 'rgb(95, 159, 84)',
      label: __('Change text color to green (%s)'),
    },
    {
      value: 'rgb(127, 187, 118)',
      label: __('Change text color to green (%s)'),
    },
    {
      value: 'rgb(170, 214, 164)',
      label: __('Change text color to green (%s)'),
    },
  ],
  [
    {
      value: 'rgb(48, 100, 172)',
      label: __('Change text color to blue (%s)'),
    },
    {
      value: 'rgb(70, 147, 231)',
      label: __('Change text color to blue (%s)'),
    },
    {
      value: 'rgb(91, 174, 243)',
      label: __('Change text color to blue (%s)'),
    },
    {
      value: 'rgb(122, 202, 247)',
      label: __('Change text color to blue (%s)'),
    },
  ],
  [
    {
      value: 'rgb(107, 41, 132)',
      label: __('Change text color to purple (%s)'),
    },
    {
      value: 'rgb(153, 62, 195)',
      label: __('Change text color to purple (%s)'),
    },
    {
      value: 'rgb(179, 91, 223)',
      label: __('Change text color to purple (%s)'),
    },
    {
      value: 'rgb(201, 135, 236)',
      label: __('Change text color to purple (%s)'),
    },
  ],
]
